import React, {useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./DateTime.css";
import htmlParser from "html-react-parser";

export default function Banner({ dateTime, loanOfficer, loInformation }) {
  const imgCDNUrl = process.env.REACT_APP_CDN_URL;
 

  return (
    <>
      <div className="completedattimesectiion">
        <Container>
          <Row>
            <Col sm={12} md={12} lg={12} xl={12}>
              <div className="disdivdate">
                <p className="homeownershipdiv">
                  {htmlParser(dateTime.dateDisclaimer)}
                </p>
              </div>
              <div className="homeownershipdivdouble">
                <div>
                  <div className="caldivdflex">
                    <img
                      src={imgCDNUrl + "calendericon.webp"}
                      alt="calendericon"
                      className="calenderimg"
                    ></img>
                    <p className="datep">{htmlParser(dateTime.date)}</p>
                  </div>
                  <div className="caldivdflex">
                    <img
                      src={imgCDNUrl + "clockicon.webp"}
                      alt="clock icon"
                      className="calenderimg"
                    ></img>
                    <p className="datep">{htmlParser(dateTime.time)}</p>
                  </div>
                  <div className="caldivdflex">
                    <img
                      src={imgCDNUrl + "zoommeet.webp"}
                      alt="zoom meet"
                      className="calenderimg"
                    ></img>
                    <a
                      href={htmlParser(dateTime.zoommeeturl)}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="datep">
                        {htmlParser(dateTime.zommmeettitle)}
                      </p>
                    </a>
                  </div>
                  <div className="caldivdflex">
                    <img
                      src={imgCDNUrl + "investicon.webp"}
                      alt="invest icon"
                      className="calenderimg"
                    ></img>
                    <p className="datep">{htmlParser(dateTime.investtitle)}</p>
                  </div>
                </div>
              </div>
              <div className="">
                <p className="homeownershipdivsecond">
                  {htmlParser(dateTime.joinDisclaimer)}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
